export const livingWageHours = {
  title: 'Paid work',
  subtitle:
    'Suggest paid-work tasks from work streams you can pick up. Jobs reserve hours from the shared £15ph pool and need approval.',
  backToOrg: 'Back to Organisation menu',
  openWorkStreamBoard: 'Work Stream Board',
  rateLabel: '£{{rate}} per hour',
  pool: {
    available: 'Available',
    reserved: 'Reserved',
    used: 'Used',
    carryIn: 'Carried over',
    allowance: '{{hours}} monthly allowance',
    syncedFromKitty: 'at £{{rate}}/h',
    period: 'Period {{period}}',
    value: 'Pool value {{value}}',
    editAllowance: 'Override pooled hours',
  },
  poolEdit: {
    title: 'Override monthly pooled hours',
    description:
      'Monthly hours normally come from (company kitty − annual costs) ÷ 12 ÷ £{{rate}}/h. Override here if needed; saving a budget tracker will sync again from kitty.',
    hours: 'Monthly pooled hours',
    help: 'This temporarily changes the monthly allowance for the organisation pool.',
    save: 'Save pooled hours',
    cancel: 'Cancel',
  },
  tasks: {
    title: 'Available paid work jobs',
    description:
      'Contribution tasks from OVERHEAR Paid work streams. Suggest a job to reserve hours while it awaits approval.',
    empty: 'No paid work tasks available right now',
    emptyDescription:
      'Suggest a new task below, or add contribution tasks to OVERHEAR Paid work streams on the Work Stream Board.',
    openWorkStream: 'Open work stream',
    estimated: 'Est. {{hours}}',
    claimed: 'Claimed',
    available: 'Available',
    openForMoreClaims: 'Open to more people',
    multipleClaims: 'Multiple claims allowed',
    suggest: 'Reserve',
    alreadyPending: 'Already reserved',
    suggestNew: 'Suggest new task',
  },
  newTask: {
    title: 'Suggest a new paid work task',
    intro:
      'Describe the task you want to pick up, then place it in a larger work stream — existing or new — so the work stays connected to a clear intention.',
    taskTitle: 'Task title',
    taskDescription: 'Task description (optional)',
    placementLabel: 'Which larger work stream does this fit into?',
    placementHelp:
      'Every paid work task belongs to a work stream document. Choose an existing one, or start a new stream for this piece of work.',
    existing: 'An existing work stream',
    new: 'A new work stream',
    existingPicker: 'Work stream',
    existingPlaceholder: 'Search work streams…',
    willMarkLivingWage: 'will be marked Paid work',
    workStreamTitle: 'New work stream title',
    workStreamTitleHelp:
      'Name the larger piece of work this task contributes to — not just the task itself.',
    intention: 'Work stream intention (optional)',
    intentionHelp: 'Why this larger stream of work exists.',
    submit: 'Create task & reserve hours',
  },
  reservations: {
    title: 'Suggested, reserved and completed work',
    description:
      'Suggested jobs awaiting approval, reserved hours in progress, and completed paid work — including settled meeting time.',
    empty: 'No suggested, reserved, or completed work yet',
    emptyDescription: 'Reserve a paid work job from the list to get started.',
    mySuggestions: 'My work',
    allSuggestions: 'All work',
    pendingReview: 'Pending review',
    hours: '{{hours}}',
    pairedHours: '{{hours}} (paired · was {{baseHours}})',
    value: '{{value}}',
    suggestedBy: 'Suggested by {{name}}',
    workingWith: 'Working with {{name}}',
    invitePending: 'Invite pending · {{name}}',
    invite: 'Invite to work together',
    agreeToPartner: 'Agree to partner',
    declinePartner: 'Decline',
    note: 'Note',
    cancel: 'Cancel reservation',
    complete: 'Mark complete',
    approve: 'Approve',
    reject: 'Reject',
    cannotReviewOwn: 'Another admin must approve this suggestion',
    fromMeeting: 'From meeting',
    meetingChargeAttributedTo: 'Charged to {{name}}',
    meetingChargeSubtitle: 'Settled meeting · your attendance · {{count}} agenda items',
    meetingChargeAgenda: '{{title}} ({{hours}} · {{value}} · {{bucket}})',
    meetingChargeBucketPaidWork: 'paid work',
    meetingChargeBucketProject: 'project{{project}}',
    meetingChargeBreakdown:
      'Paid work {{livingWage}} ({{livingWageHours}}) · project {{project}} ({{projectHours}})',
    status: {
      pending: 'Pending approval',
      approved: 'Approved',
      rejected: 'Rejected',
      cancelled: 'Cancelled',
      completed: 'Completed',
      meeting: 'Meeting',
    },
  },
  dialog: {
    title: 'Suggest paid work job',
    task: 'Task',
    workStream: 'Work stream',
    hours: 'Hours to reserve',
    hoursHelp: 'Taken from the shared monthly pool at £{{rate}}/hour.',
    inviteCollaborator: 'Invite someone to work on this with me',
    inviteHelp:
      'They will be emailed and asked to agree. On agreement, allotted time doubles from {{hours}} to {{total}} and the task is added to their to-do list.',
    note: 'Note (optional)',
    notePlaceholder: 'Why you can pick this up, timing, or constraints…',
    available: '{{hours}} available in the pool',
    submit: 'Reserve & submit for approval',
    cancel: 'Cancel',
  },
  invite: {
    title: 'Invite someone to work together',
    task: 'Task',
    description:
      'They will be emailed and asked to agree to partner. On agreement, allotted time doubles from {{hours}} to {{total}} (drawn from the shared pool) and the task is added to their work stream to-do list.',
    colleague: 'Admin',
    colleaguePlaceholder: 'Choose an org admin or super admin…',
    available: '{{hours}} available in the pool (extra hours reserved when they agree)',
    insufficientHours: 'Pool is low — they may not be able to agree until more hours are available',
    submit: 'Email invite',
    cancel: 'Cancel',
  },
  success: {
    suggested: 'Job suggested and hours reserved pending approval',
    suggestedWithCollaborator:
      'Job suggested and partner emailed — hours double when they agree',
    newTaskSuggested: 'New task created, linked to a work stream, and hours reserved',
    approved: 'Suggestion approved and task assigned',
    rejected: 'Suggestion rejected and hours released',
    cancelled: 'Reservation cancelled and hours released',
    completed: 'Reservation marked complete',
    poolUpdated: 'Monthly pooled hours updated',
    collaboratorInvited: 'Partner emailed — hours double when they agree',
    partnerAccepted: 'Partnership agreed — hours doubled and to-do added',
    partnerDeclined: 'Partnership invite declined',
  },
  errors: {
    loadFailed: 'Failed to load paid work hours',
    suggestFailed: 'Failed to suggest job',
    reviewFailed: 'Failed to update approval',
    cancelFailed: 'Failed to cancel reservation',
    completeFailed: 'Failed to complete reservation',
    inviteFailed: 'Failed to invite collaborator',
    insufficientHours: 'Not enough hours left in the paid work pool',
    invalidHours: 'Enter a valid number of hours',
    poolUpdateFailed: 'Failed to update monthly pooled hours',
  },
};
